import store from "@/store"
import { headers, API_BASE_URL } from './apiClient'

const REAL_API = `${API_BASE_URL}/v1/chat`
const MOCK_API = `${API_BASE_URL}/v1/chat_mock`

export async function sendMessageStream(messages, engineId, conversationId) {
  const useMock = store.getters["settings/useMockApi"]
  const systemPrompt = store.getters["settings/systemPrompt"]
  const overrideSystemPrompt = store.getters["settings/overrideSystemPrompt"]
  const url = useMock ? MOCK_API : REAL_API

  const body = JSON.stringify({
    messages: messages.map(m => ({ role: m.role, content: m.content })),
    engine_id: engineId,
    conversation_id: conversationId ?? null,
    prompt: overrideSystemPrompt ? systemPrompt : null,
  })

  let response
  try {
    response = await fetch(url, {
      method: "POST",
      headers: headers(),
      body,
    })
  } catch (e) {
    e.isNetworkError = true
    throw e
  }

  if (!response.ok) {
    const data = await response.json().catch(() => ({}))
    const err = new Error(data.error || `Erreur HTTP ${response.status}`)
    err.status = response.status
    throw err
  }

  return response
}
